'use client';
import React__default, { Component } from 'react';
import { logError } from '../../utils/logging.js';

class ErrorBoundary extends Component {
  static displayName = 'BricksErrorBoundary';
  state = {
    hasError: false,
    error: null,
    errorInfo: null
  };
  componentDidCatch(error, errorInfo) {
    if (this.props.production) {
      console.error('ErrorBoundary:error', error);
      console.error('ErrorBoundary:errorInfo', errorInfo);
      logError(new Error(`ErrorBoundary: ${error?.toString()} ${errorInfo?.componentStack}`));
    }
    this.setState({
      hasError: true,
      error,
      errorInfo
    });
  }
  render() {
    const {
      children,
      production,
      title,
      message,
      component: Component
    } = this.props;
    const {
      error,
      errorInfo,
      hasError
    } = this.state;
    if (hasError) {
      return /*#__PURE__*/React__default.createElement("section", {
        className: "error-boundary"
      }, title && /*#__PURE__*/React__default.createElement("h1", null, title), message && /*#__PURE__*/React__default.createElement("p", null, message), Component && /*#__PURE__*/React__default.createElement(Component, null), !production && error && /*#__PURE__*/React__default.createElement("details", {
        open: true
      }, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("strong", null, error.toString()), /*#__PURE__*/React__default.createElement("br", null), Boolean(errorInfo?.componentStack) && errorInfo?.componentStack));
    }
    return children;
  }
}

export { ErrorBoundary };
